module.exports = __webpack_public_path__ + "media/companies/FDC-eb36b23d.png";